import React from 'react'
import { ethers } from 'ethers'
import { Form, Formik } from 'formik'
import { useActiveWeb3React } from '../../../../hooks'
import { useAddPopup } from '../../../../state/application/hooks'
import NFTInput from '../../components/NFTInput/NFTInput'
import { Title } from '../Create/NFTCreate/NFTCreateStyled'
import {
  AccountDetailSaveBtn,
  PageContent,
  PageWrapper,
  ProfileFormImageInputWrapper,
  ProfileFormImageSection
} from './AccountDetailsStyled'
import ValidateAccountData from './ValidateAccountData'
import NFTShareProfile from '../../components/NFTShareProfile'
import NFTUserAvatar from '../../components/NFTUserAvatar'
import NFTUpload from '../../components/NFTUpload/NFTUpload'
import useNFTUserData from '../../data/useNFTUserData'
import { ProfileServices } from '../../data/Services'
import INFTUserData from '../../models/INFTUserData'
import Api from '../../../../services/Api'
import { Helmet } from 'react-helmet'
import NFTButton from '../../newComponents/NFTButton'
import Scrollbar from '../../components/Scrollbar'
//@ts-ignore
import { Web3Storage } from 'web3.storage/dist/bundle.esm.min.js'

const IPFS_URL = 'https://ipfs.io/ipfs/'

const ipfsStorage = new Web3Storage({ token: process.env.REACT_APP_STORAGE_KEY })

const AccountDetails = (props: any) => {
  const { account, library } = useActiveWeb3React()

  const [errorMessages, setErrorMessages] = React.useState<any>({})

  const [accountData, setAccountData] = React.useState<any>({})

  const [refetchData, setReFetchData] = React.useState(false)

  const currentData = useNFTUserData(account as string, refetchData)

  React.useEffect(() => {
    // burası bir sebepten -1 dönüyor ve bütün akılşı bozuyor diğer yerleri etkilememk adına burada böyle kontrol yapıldı
    // @ts-ignore
    if (currentData.userData && currentData.userData !== -1) {
      setAccountData(currentData.userData)
    }
  }, [currentData.loading])

  const addPopup = useAddPopup()

  const getCurrentData = (key: string) => {
    if (currentData?.userData) {
      return currentData.userData[key as keyof INFTUserData]
    }
    return null
  }

  const validateData = async (key: string, value: any) => {
    const currentValue = getCurrentData(key)
    const validationResult = await ValidateAccountData(key, value, currentValue)
    if (validationResult !== true) {
      setErrorMessages((state: any) => ({ ...state, [key]: validationResult }))
      return false
    } else {
      setErrorMessages((state: any) => ({ ...state, [key]: null }))
    }
    return true
  }

  const validateAllFields = async (data: any) => {
    let result = true
    for (const key of Object.keys(data)) {
      const vResult = await validateData(key, data[key])
      if (vResult === false) {
        result = false
        //break;
      }
    }
    return result
  }

  const signMessage = async () => {
    try {
      let message =
        "By Signing this message you are confirming that you are authorized to use this account and you are about to change account detail information's on YetiSwap NFT Marketplace. Nonce="
      const nonce: string = await ProfileServices.GetNonceForUser(account as string)
      message += nonce
      const signer = await library?.getSigner()
      const signature = await signer?.signMessage(message)
      if (signature && account) {
        const signerAddress = await ethers.utils.verifyMessage(message, signature)
        if (signerAddress === account) {
          return signature
        }
      }
      return false
    } catch (error) {
      return false
    }
  }

  const onSubmit = async (data: any) => {
    const isUsernameValid = await validateData('username', data.username)
    if (isUsernameValid) {
      const isFieldsValid = await validateAllFields(accountData)
      if (isFieldsValid) {
        const signResult = await signMessage()
        if (signResult && typeof signResult == 'string') {
          const requestBody = {
            ...accountData,
            signature: signResult
          }
          const saveResult = await ProfileServices.SaveUserProfile(account as string, requestBody)

          sessionStorage.removeItem(account?.toLowerCase() as string)
          setReFetchData(true)
          addPopup({
            txn: {
              hash: '',
              success: saveResult,
              summary: signResult ? 'Account Information Saved!' : 'Account Information save failed!',
              linkRemove: true
            }
          })
        }
      }
    }
  }

  const onChangeValue = (key: string) => (value: any) => {
    setAccountData({ ...accountData, [key]: value })
  }

  const onURLCopied = () => {
    addPopup({
      txn: { hash: '', success: true, summary: 'Profile Link copied to your clipboard', linkRemove: true }
    })
  }

  const uploadFile = (file: File) => {
    if (validateFile(file)) {
      const formData = new FormData()
      formData.append('file', file)
      ipfsStorage.put([file], { wrapWithDirectory: false }).then((Hash: any) => {
        if (Hash) {
          setAccountData({ ...accountData, profileImgUrl: IPFS_URL + Hash })
        }
      })
    }
  }

  const setFileErrorMessage = (message: any) => {
    setErrorMessages({ ...errorMessages, profilePhotoFile: message })
  }

  const validateFile = (file: File) => {
    const fileTypes = ['image/png', 'image/jpeg']
    if (!file) {
      setFileErrorMessage(null)
      return false
    } else if (fileTypes.indexOf(file.type) === -1) {
      setFileErrorMessage('Only PNG and JPEG files can be uploaded.')
      return false
    } else if (file && Math.round(file.size / 1024) > 10240) {
      setFileErrorMessage('File size should be less than 10MB')
      return false
    } else {
      setFileErrorMessage(null)
      return true
    }
  }

  const setImageFile = (data: any) => {
    if (data?.file) {
      uploadFile(data.file)
    }
  }

  const renderForm = (formikProps: any) => {
    return (
      <Form encType="multipart/form-data" autoComplete="off">
        <NFTShareProfile accountAddress={account || ''} label={'Share Profile'} onURLCopied={onURLCopied} />
        <ProfileFormImageSection>
          <NFTUserAvatar
            accountAddress={account || ''}
            profileImgUrl={accountData?.profileImgUrl}
            height={200}
            width={200}
            style={{ margin: 10 }}
          />
          <ProfileFormImageInputWrapper>
            <NFTInput
              id="profileImgUrl"
              name="profileImgUrl"
              label="Profile Image Url"
              value={formikProps.values?.profileImgUrl}
              placeholder={'https://..../image.png'}
              optional={true}
              errorMessage={errorMessages.profileImgUrl}
              onKeyUp={onChangeValue('profileImgUrl')}
            />
            <NFTUpload
              accept="image/png,image/jpeg"
              description="PNG, JPEG Max 10mb."
              id="profilePhotoFile"
              name="profilePhotoFile"
              label="Upload file"
              setFieldValue={setImageFile}
              value={null}
              errorMessage={errorMessages.profilePhotoFile}
            />
          </ProfileFormImageInputWrapper>
        </ProfileFormImageSection>
        <NFTInput
          id="username"
          name="username"
          label="User Name"
          value={formikProps.values?.username}
          placeholder={'Your User Name'}
          optional={false}
          errorMessage={errorMessages?.username}
          onKeyUp={onChangeValue('username')}
        />
        <NFTInput
          id="email"
          name="email"
          label="Email"
          value={formikProps.values?.email}
          placeholder={'yourname@mail.com'}
          optional={true}
          errorMessage={errorMessages.email}
          onKeyUp={onChangeValue('email')}
        />
        <NFTInput
          id="bio"
          name="bio"
          label="Bio"
          value={formikProps.values?.bio}
          placeholder={'Tell us about yourself'}
          optional={true}
          onKeyUp={onChangeValue('bio')}
        />
        <NFTInput
          id="twitterUrl"
          name="twitterUrl"
          label="Twitter URL"
          value={formikProps.values?.twitterUrl}
          placeholder={'https://www.twitter.com/@YourUserName'}
          optional={true}
          errorMessage={errorMessages.twitterUrl}
          onKeyUp={onChangeValue('twitterUrl')}
        />
        <NFTInput
          id="instagramUrl"
          name="instagramUrl"
          label="Instagram URL"
          value={formikProps.values?.instagramUrl}
          placeholder={'https://www.instagram.com/@YourUserName'}
          optional={true}
          errorMessage={errorMessages.instagramUrl}
          onKeyUp={onChangeValue('instagramUrl')}
        />
        <NFTInput
          id="websiteUrl"
          name="websiteUrl"
          label="Website URL"
          value={formikProps.values?.websiteUrl}
          placeholder={'https://www.yourwebsite.com/'}
          optional={true}
          errorMessage={errorMessages.websiteUrl}
          onKeyUp={onChangeValue('websiteUrl')}
        />
        <NFTButton htmlType="submit">Save</NFTButton>
      </Form>
    )
  }

  const renderContent = () => {
    if (!account) return <div className="text">You should connect your wallet to see this page.</div>
    return (
      <Formik onSubmit={(values: any) => onSubmit(values)} initialValues={accountData} enableReinitialize>
        {renderForm}
      </Formik>
    )
  }

  return (
    <PageWrapper>
      <Helmet>
        <title>Account Details - YetiSwap NFT Marketplace</title>
      </Helmet>
      <Scrollbar>
        <PageContent>
          <Title>Account Details</Title>
          {renderContent()}
        </PageContent>
      </Scrollbar>
    </PageWrapper>
  )
}

export default AccountDetails